module.exports = __webpack_public_path__ + "components/forecast-table/static/freezing-graph_backdrop-snow-4595a66b1b99bf4536dd0919a1ddcce3.jpg";